import React, { Fragment, useEffect, useMemo, useState } from 'react'
import ContractBulletItemPure from './contract-bullet-item.pure'
import ContractBulletHeaderPure from './contract-bullet-header.pure'
import { Grid } from '@material-ui/core'
import './contract-bullet.css';
import { LocalStorageService } from '../../../services'
import PdfViewer from '../../pures/syncFusionPdfViewer/pdf-viewer'
import { useTranslation } from 'react-i18next'


const localStorageService = new LocalStorageService()

const ContractBulletPure = (props) => {
  const [getpdf, setGetPdf] = useState(false)
  const { t } = useTranslation()

  const language = localStorageService.getLocalStorageItem("preferredLanguage")
  const urlToCall = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_RELATIVE_URL_PDF_TERMS_CONDS}`.replace("{languageToReplace}", language ?? "es")
  const pdfAWS = useMemo(() => <PdfViewer t={t} url={urlToCall} />, [getpdf, language])

  useEffect(() => {
    setGetPdf(true)
  }, [])

  return (
    <Fragment>
      <Grid item lg={12} md={12} sm={12} es={12} xs={12} >
        <div className='contractBulletPure-container'>
          {/* <Grid container spacing={2}> */}
          <ContractBulletHeaderPure />
          <div className='dialogTermsCond-pdf'>
            {pdfAWS}
          </div>
          {/* <ListView
            style={{ color: '#484848' }}
            data={props.data}
            header={ContractBulletHeaderPure}
            item={ContractBulletItemPure}
          /> */}
          {/* <ContractBulletListPure
          {...props}
        /> */}
        </div>
      </Grid>
    </Fragment>
  )
}

export { ContractBulletPure as default }
